import $ from 'jquery';

const flexibleContentMenuItems = $('.flexible-content-menu-items'),
  flexibleContentSections = $('.flexible-content-blocks section');

function scrollTo(scrollTarget) {
  const stickyHeaderHeight = $('.header-section--sticky').height() + 70;
  $('html, body').animate(
    {
      scrollTop:
        $('section[data-nav-title="' + scrollTarget + '"]').offset().top -
        stickyHeaderHeight,
    },
    500
  );
}

if ($('.flexible-content-blocks section[data-nav-title]').length) {
  $.each(flexibleContentSections, function () {
    let menuItemTitle = $(this).attr('data-nav-title');
    let menuItemURL = $(this).attr('data-nav-url');
    if (typeof menuItemTitle !== 'undefined') {
      if (typeof menuItemURL !== 'undefined') {
        let menuItem =
          '<a class="flexible-content-menu-item" target="_blank" role="button" tabindex="0" href="' +
          menuItemURL +
          '"><span class="border"></span>' +
          menuItemTitle +
          '</a>';
        flexibleContentMenuItems.append(menuItem);
      } else {
        let menuItem =
          '<span class="flexible-content-menu-item" tabindex="0" role="button" data-nav-title="' +
          menuItemTitle +
          '"><span class="border"></span>' +
          menuItemTitle +
          '</span>';
        flexibleContentMenuItems.append(menuItem);
      }
    }
  });

  $('.flexible-content-menu-item').on('click', function (e) {
    if (typeof $(this).attr('href') === 'undefined') {
      e.preventDefault();
      let scrollTarget = $(this).attr('data-nav-title');
      $('.flexible-content-menu-item').removeClass('opened');
      $(this).addClass('opened');
      scrollTo(scrollTarget);
    }
  });
  $('.flexible-content-menu-item').on('keydown', function (e) {
    if (typeof $(this).attr('href') === 'undefined') {
      if (e.key == 'Enter') {
        let scrollTarget = $(this).attr('data-nav-title');
        $('.flexible-content-menu-item').removeClass('opened');
        $(this).addClass('opened');
        scrollTo(scrollTarget);
      }
    }
  });
  $('body').addClass('has-nav');
  $('.flexible-content-menu').show();
} else {
  $('.flexible-content-menu').hide();
}

$(document).ready(function() {
  $('.content-block table, .content-block-cs table').each(function() {
    if (!$(this).parent().hasClass('table-wrap')) {
      $(this).wrap('<div class="table-wrap"></div>');
    }
  });
});
